import { RequestCustomerStatus } from 'cpfr-common';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';
import { AbstractDataState, useGetSimpleApiData } from '@cp-shared-19/frontend-integration';
import { AddressChangeStatusSelector } from './AddressChangeStatusSelector';
import { fetchAddressChangeStatus } from './AddressChangeStatusSlice';

export function useAddressChangeStatus(): AbstractDataState<RequestCustomerStatus, DefaultBusinessMarketApiErrorCode> {
    return useGetSimpleApiData(fetchAddressChangeStatus, AddressChangeStatusSelector, true);
}
